import React, { useState, useEffect } from "react";
import { Form, Row, Col, Card, notification, Button, Modal } from "antd";
import jsonfile from "./migration.json";
import { CisUI } from "../../../../util/CISUI";
import "react-smart-data-table/dist/react-smart-data-table.css";
import Config from "../../../../util/config";
import axios from "../../../../util/Api";
import { useHistory } from "react-router-dom";
import "react-smart-data-table/dist/react-smart-data-table.css";
import moment from "moment/moment";

const MigrationRequestDetails = (props) => {
  const formRef = React.createRef();
  const [companyLevel, setCompanyLevel] = useState(0);
  const [local, setLocal] = useState([]);
  const [district, setDistrict] = useState([]);
  const [destinationDistrict, setDestinationDistrict] = useState([]);
  const [status, setStatus] = useState({});
  const userID = props.match.params.id;
  const [data, setData] = useState({});
  const [state, setState] = useState({
    reqURL: Config.apiserver + jsonfile.urls.companyuserlist + "/" + userID,
    filtervalue: "",
    area: null,
  });

  const [diplay, setDisplay] = useState({
    region: "none",
    district: "none",
    local: "none",
    destinationRegion: "none",
    destinationDistrict: "none",
  });
  const [required, setRequired] = useState({
    region: false,
    district: false,
    local: false,
    destinationRegion: false,
    destinationDistrict: false,
  });
  const [form] = Form.useForm();

  const history = useHistory();

  let endpoint = "company/updatemigrationrequest/" + userID;
  let redirectTo = "../../" + jsonfile.urls.list;

  const onRegionChange = (value) => {
    console.log("fromedd", value);
    form.setFieldsValue({ district: null });
    axios
      .get("districtsbyregion/" + value)
      .then((res) => {
        if (res.data.status === 1) {
          const districtList = res.data.data;
          setDistrict(districtList);
        } else {
          CisUI().showAlert("Alert", "warning", res?.data?.msg);
        }
      })
      .catch((errors) => {
        console.log(errors);
      });
  };

  const onDestinationRegionChange = (value, level = companyLevel) => {
    form.setFieldsValue({ destination_district: null });
    if (level === 6) {
      axios
        .get("districtsbyregion/" + value)
        .then((res) => {
          if (res.data.status === 1) {
            const districtList = res.data.data;
            setDestinationDistrict(districtList);
          } else {
            CisUI().showAlert("Alert", "warning", res?.data?.msg);
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    }
  };

  const onDistrictChange = (value, level = companyLevel) => {
    // console.log(companyLevel);
    // console.log(typeof companyLevel);
    console.log("fromedd", value);
    console.log("fromedd", companyLevel);
    form.setFieldsValue({ local: null });
    if (level === 6) {
      console.log("fromedd", value);
      axios
        .get("localsbydistrict/" + value)
        .then((res) => {
          if (res.data.status === 1) {
            const locallist = res.data.data;
            setLocal(locallist);
          } else {
            CisUI().showAlert("Alert", "warning", res?.data?.msg);
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    }
  };

  useEffect(() => {
    document.getElementById("loader").style.display = "block";
    axios
      .get(Config.apiserver + jsonfile.urls.details + "/" + userID)
      .then((res) => {
        // console.log(res.data)
        document.getElementById("loader").style.display = "none";
        if (res.data.status === 1) {
          setData(res?.data?.data);
          let areaValue = res?.data?.data?.area;
          setStatus(res?.data?.data?.status);
          setCompanyLevel(areaValue);
          console.log("area value", companyLevel);
          if (areaValue === 5) {
            onRegionChange(res.data.data.region);
            setDisplay({
              region: "block",
              district: "block",
              local: "none",
              destinationRegion: "block",
              destinationDistrict: "none",
            });
            setRequired({
              region: true,
              district: true,
              local: false,
              destinationRegion: true,
              destinationDistrict: false,
            });
          } else if (areaValue === 6) {
            onRegionChange(res?.data?.data?.region);
            onDistrictChange(res?.data?.data?.district, areaValue);
            onDestinationRegionChange(res?.data?.data?.destination_region, areaValue);
            setDisplay({
              region: "block",
              district: "block",
              local: "block",
              destinationRegion: "block",
              destinationDistrict: "block",
            });
            setRequired({
              region: true,
              district: true,
              local: true,
              destinationRegion: true,
              destinationDistrict: true,
            });
          }

          form.setFieldsValue({
            area: res?.data?.data?.area,
            region: res?.data?.data?.region,
            district: res?.data?.data?.district,
            local: res?.data?.data?.local,
            // 'effective_date': res?.data?.data?.effective_date,
            // 'effective_date': moment(res.data.data.effective_date).format('MM/DD/YYYY'),
            destination_region: res?.data?.data?.destination_region,
            destination_district: res?.data?.data?.destination_district,
          });
        } else {
          notification.warning({
            message: "Alert",
            type: "warning",
            description: res.data.msg,
          });
        }
      })
      .catch((errors) => {
        if (document.getElementById("loader") !== undefined) {
          document.getElementById("loader").style.display = "none";
        }
        console.log(errors);
      });
  }, []);

  const onFinish = (values) => {
    // setLoading({loading:true})
    let data = {
      ...values,
      effective_date: moment(values?.effective_date).format("YYYY-MM-DD"),
    };
    // console.log("Input Data : ", data);
    // return;
    document.getElementById("loader").style.display = "block";

    axios
      .post(Config.apiserver + endpoint, data)
      .then((res) => {
        // console.log(res)
        document.getElementById("loader").style.display = "none";
        if (res.data.status === 1) {
          notification.success({
            message: "Success",
            type: "warning",
            description: res.data.msg,
          });
          history.push(redirectTo);
        } else {
          notification.warning({
            message: "Alert",
            type: "warning",
            description: res.data.msg,
          });
        }
      })
      .catch((errors) => {
        if (document.getElementById("loader") !== undefined) {
          document.getElementById("loader").style.display = "none";
        }
        console.log(errors);
      });
  };

  const handleApproved = () => {
    document.getElementById("loader").style.display = "block";
    axios
      .get(Config.apiserver + "company/approvemigrationrequest/" + userID)
      .then((res) => {
        if (res.data.status === 1) {
          setStatus(1);
          notification.success({
            message: "Success",
            type: "warning",
            description: res.data.msg,
          });
        } else {
          notification.warning({
            message: "Alert",
            type: "warning",
            description: res.data.msg,
          });
        }
        document.getElementById("loader").style.display = "none";
      })
      .catch((errors) => {
        if (document.getElementById("loader") !== undefined) {
          document.getElementById("loader").style.display = "none";
        }
        console.log(errors);
      });
  };

  const handleApprove = () => {
    Modal.confirm({
      title:
        "Are you sure you want approve this request?After approval, the data cannot be reverted to its original state.",
      centered: true,
      onOk: () => handleApproved(),
      okText: "Yes",
      cancelText: "No",
      width: "600px",
      // content: 'Bla bla ...',
      footer: (_, { OkBtn, CancelBtn }) => (
        <div style={{ textAlign: "center" }}>
          <CancelBtn />
          <OkBtn />
        </div>
      ),
    });
  };

  return (
    <>
      <Card title="Migration Request Details" extra={CisUI().addAction(redirectTo)}>
        {CisUI().showLoading}
        <Form
          form={form}
          ref={formRef}
          {...CisUI().formItemLayout}
          name="input"
          className="ant-advanced-search-form"
          onFinish={onFinish}
          initialValues={{ area: state.area }}
        >
          <Row>
            <Col lg={12} md={12} sm={24} xs={24}>
              <Card title="Source Entity">
                <Row>
                  <Col lg={12} md={12} sm={24} xs={24}>
                    <div className="gx-form-row0" style={{ paddingBottom: "24px" }}>
                      <h4>Level of Department/Branch</h4>
                      <p>{data?.area_name}</p>
                    </div>
                  </Col>

                  <Col
                    lg={12}
                    md={12}
                    sm={24}
                    xs={24}
                    id="region"
                    style={{ display: diplay.region, paddingBottom: "24px" }}
                  >
                    <div className="gx-form-row0">
                      <h4>Region</h4>
                      <p>{data?.region_name}</p>
                    </div>
                  </Col>

                  <Col
                    lg={12}
                    md={12}
                    sm={24}
                    xs={24}
                    id="district"
                    style={{ display: diplay.district, paddingBottom: "24px" }}
                  >
                    <div className="gx-form-row0">
                      <h4>District</h4>
                      <p>{data?.district_name}</p>
                    </div>
                  </Col>

                  <Col
                    lg={12}
                    md={12}
                    sm={24}
                    xs={24}
                    id="local"
                    style={{ display: diplay.local, paddingBottom: "24px" }}
                  >
                    <div className="gx-form-row0">
                      <h4>Local Assembly</h4>
                      <p>{data?.local_name}</p>
                    </div>
                  </Col>
                </Row>
              </Card>
            </Col>
            <Col lg={12} md={12} sm={24} xs={24}>
              <Card title="Destination Entity">
                <Row>
                  <Col lg={12} md={12} sm={24} xs={24}>
                    <div className="gx-form-row0" style={{ paddingBottom: "24px" }}>
                      <h4>Effective Date</h4>
                      <p>{moment(data?.effective_date).format("MM/DD/YYYY")}</p>
                    </div>
                  </Col>

                  <Col
                    lg={12}
                    md={12}
                    sm={24}
                    xs={24}
                    id="destinationregion"
                    style={{ display: diplay.destinationRegion, paddingBottom: "24px" }}
                  >
                    <div className="gx-form-row0">
                      <h4>Destination Region</h4>
                      <p>{data?.destination_region_name}</p>
                    </div>
                  </Col>

                  <Col
                    lg={12}
                    md={12}
                    sm={24}
                    xs={24}
                    id="destinationdistrict"
                    style={{ display: diplay.destinationDistrict, paddingBottom: "24px" }}
                  >
                    <div className="gx-form-row0">
                      <div className="gx-form-row0">
                        <h4>Destination District</h4>
                        <p>{data?.destination_district_name}</p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>

          <Row>
            <div className="col-md-12" style={{ textAlign: "center", marginTop: "30px" }}>
              {/*<Button id="submitbutton" type="primary" htmlType="submit">*/}
              {/*    Save*/}
              {/*</Button>*/}
              {/*<Button id="resetButton" type="primary" htmlType="reset">Reset</Button>*/}
              <Button type="info" onClick={() => history.goBack()}>
                Back
              </Button>
              {status === 0 && (
                <Button type="info" onClick={handleApprove}>
                  Approve
                </Button>
              )}
            </div>
          </Row>
        </Form>
      </Card>
    </>
  );
};

export default MigrationRequestDetails;
